<template>
  <div>

    <table v-if="isRaceVisible" class="prop-table mb-1">
      <tr>
        <th>Created at</th>
        <td>{{race.ctime | getMomentStr}}</td>
      </tr>
      <tr>
        <th>Player amount</th>
        <td>{{race.participantAmount | getFormattedNumber}}</td>
      </tr>
      <tr>
        <th>Status</th>
        <td :class="statusClass">
          {{race.status | getRushRaceStatusName}}
        </td>
      </tr>
    </table>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { getRushRaceStatusName } from '../model/rush_race.js';
import { getRushStatusClass    } from '../model/rush_race.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'RushRaceInfo',

  components: {
    LoadingIndicator,
  },

  props: {
    rushRaceId: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?Object} */
      race: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    isRaceVisible() {
      return this.isLoadedNormal && (this.race !== null);
    },

    statusClass() {
      return getRushStatusClass(this.race.status);
    },
  },

  created() {
    this.loadRace();
  },

  methods: {
    loadRace() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const rushId = this.rushRaceId.rushId;
      const raceId = this.rushRaceId.raceId;
      const url = `/rush/${rushId}/race/${raceId}`;

      HTTP.get(url)
      .then(response => {
        this.race = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },

  filters: {
    getRushRaceStatusName,
  },

};
</script>
